import { Reply, X } from "lucide-react";
import { Button } from "../atoms/Button/index.js";
import { Tooltip } from "../molecules/Tooltip/index.js";

/**
 * Task 7 — the Player AI response the next message replies to, as one line
 * above the input, with × to cancel the selection. No label and no quote bar:
 * the curved arrow is the only marker.
 */
export function ComposerReplyPreview({
  text,
  onCancel,
}: {
  text: string;
  onCancel: () => void;
}) {
  return (
    <div
      data-composer-reply
      className="mb-1.5 flex min-w-0 items-center gap-1.5 rounded-md bg-pb-iris-soft/30 px-2 py-1"
    >
      <Reply className="h-3 w-3 shrink-0 text-pb-iris-text" aria-hidden />
      <span className="sr-only">Replying to Player AI: </span>
      <span className="min-w-0 flex-1 truncate text-dense-1 text-pb-text-secondary">
        {text.trim() || "Player AI response"}
      </span>
      <Tooltip content="Cancel reply" describeChild={false}>
        <Button
          variant="ghost"
          size="xs"
          iconOnly
          aria-label="Cancel reply"
          onClick={onCancel}
        >
          <X className="h-3 w-3" aria-hidden />
        </Button>
      </Tooltip>
    </div>
  );
}
